import React from "react";
import styles from "./About.module.css";
import { Asterisk, CodeBrackets, Cube, Pulse } from "../common/Icons";
import LiquidGlass from "../common/LiquidGlass";
import Reveal from "../common/Reveal";
import SectionIntro from "../common/SectionIntro";

const bentoCards = [
  {
    icon: Asterisk,
    badge: "Generative AI",
    tone: "sage",
    title: "LLM platforms, end to end",
    description:
      "Multi-environment GenAI portals for a Fortune 500 healthcare client: conversation memory that keeps token use down, admin control over model selection and limits, and document upload with file-based queries.",
    tags: ["Next.js", "OpenAI / Gemini", "LLM memory", "SSE streaming", "Node.js"],
  },
  {
    icon: CodeBrackets,
    badge: "Frontend",
    tone: "sky",
    title: "Interfaces that age well",
    description:
      "Component-driven clients in strict TypeScript, with shared design systems, predictable state in Zustand or Redux Toolkit, and accessibility treated as a requirement rather than a cleanup task.",
    tags: ["React 18", "TypeScript", "Zustand", "Redux Toolkit", "Tailwind CSS"],
  },
  {
    icon: Cube,
    badge: "3D & motion",
    tone: "clay",
    title: "WebGL without the gimmick",
    description:
      "Three.js and React Three Fiber used where depth helps someone understand something, as in the Gallefied virtual gallery. Animation kept on transform and opacity so it stays smooth.",
    tags: ["Three.js", "React Three Fiber", "Drei", "WebGL"],
  },
  {
    icon: Pulse,
    badge: "Scale",
    tone: "sand",
    title: "Built to survive release day",
    description:
      "Enterprise healthcare, US luxury e-commerce and two startup products. Bundle splitting, service worker caching and query tuning cut 30% off first load on the last one.",
    tags: ["PWA", "Performance audits", "PostgreSQL", "MongoDB", "REST APIs"],
  },
];

const About = () => (
  <section className={styles.container} id="about">
    <SectionIntro
      index="01"
      label="Background"
      title="I like the problems that span the model, the API and the interface."
      lede="Five years across Accenture, Dotchat and Publicis Sapient: a Fortune 500 healthcare GenAI portal, a conversational gifting product, and a US luxury apparel storefront."
    />

    <div className={styles.bentoGrid}>
      {bentoCards.map((card, index) => {
        const IconComponent = card.icon;
        return (
          <Reveal
            as={LiquidGlass}
            key={card.title}
            className={styles.bentoCard}
            blur="soft"
            wash
            delay={index * 70}
          >
            <div className={styles.cardTop}>
              <span className={styles.iconBox} aria-hidden="true">
                <IconComponent size={17} />
              </span>
              <span className={`${styles.cardBadge} ${styles[card.tone]}`}>{card.badge}</span>
            </div>

            <h3 className={styles.cardTitle}>{card.title}</h3>
            <p className={styles.cardText}>{card.description}</p>

            <div className={styles.tagRow}>
              {card.tags.map((tag) => (
                <span key={tag} className={styles.tag}>
                  {tag}
                </span>
              ))}
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default About;